import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../constants/endpoints";
import api from "../../services/instance";

export const updateAdminProfileAPI = createAsyncThunk(
    'updateAdminProfileAPI',
    async (data, { rejectWithValue }) => {
        try {
            const id = data.get('id');
            const response = await api.post(endpoints.updateAdminProfile(id), data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
);

const initialState = {
    loading: false
};

const AdminProfileSlice = createSlice({
    initialState,
    name: "AdminProfileSlice",
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(updateAdminProfileAPI.pending, (state, action) => {
            state.loading = true;
        });

        builder.addCase(updateAdminProfileAPI.fulfilled, (state, action) => {
            state.loading = false;
            localStorage.setItem("user", JSON.stringify(action.payload.data.data));
        });

        builder.addCase(updateAdminProfileAPI.rejected, (state, action) => {
            state.loading = false;
        });
    }
});

export const {} = AdminProfileSlice.actions;
export default AdminProfileSlice.reducer;
